import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';

// Deductible option that skips rating a quote and leaves its premiums blank in the preview
export const LEAVE_BLANK = 'Leave Blank';

// Stand-in for the rates of a quote that is left blank; no rates are fetched for it
export const BLANK_QUOTE_RATES = { blank: true };

export function isBlankQuoteRates(ratesData, quoteUid) {
    return !!ratesData?.[quoteUid]?.blank;
}

// Whether a saved plan left this quotation blank — used to restore blank quotes when editing
export function isQuoteBlankForPlan(quotation, plan) {
    const matchesPlan = p => plan.uid ? p.plan_uid === plan.uid : p.plan_id === plan.plan_id;
    return !!quotation?.client_premiums?.some(cp => cp.premiums?.find(matchesPlan)?.blank);
}

// Turn the premiums of blank quotes into empty placeholders so the preview renders that
// column as white space, and clear the flag on every other quote (e.g. un-blanked on edit).
export function applyLeaveBlank(updates, blankQuoteUids) {
    const blankSet = new Set(blankQuoteUids);
    return updates.map(update => {
        if (!blankSet.has(update.quoteUid)) {
            return { ...update, premium: { ...update.premium, blank: false } };
        }
        return {
            ...update,
            premium: {
                ...update.premium,
                blank: true,
                deductible: '',
                co_insurance: '',
                premium_rate: null,
                recommended: false,
            },
        };
    });
}

// Restores which quotes a saved plan left blank: { [quoteUid]: boolean }
export function getBlankQuotesForPlan(quotes, quotations, plan) {
    if (!plan) return {};
    return Object.fromEntries((quotes || []).map(quote => [
        quote.uid,
        isQuoteBlankForPlan((quotations || []).find(q => q.uid === quote.uid), plan),
    ]));
}

// Per-quote "Leave Blank" toggles for dialogs that have no per-quote deductible to put the option in
export function LeaveBlankPerQuote({ quotes, blankQuotes, onChange, disabled }) {
    return (
        <Box sx={{ mb: 2 }}>
            <Typography fontWeight={600} sx={{ mb: 1, fontSize: 15 }}>Leave Blank per Quote</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                {(quotes || []).map(quote => (
                    <FormControlLabel
                        key={quote.uid}
                        sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }}
                        control={
                            <Checkbox
                                size="small"
                                checked={!!blankQuotes[quote.uid]}
                                disabled={disabled}
                                onChange={(e) => onChange({ ...blankQuotes, [quote.uid]: e.target.checked })}
                            />
                        }
                        label={quote.name}
                    />
                ))}
            </Box>
        </Box>
    );
}

export function BlankQuoteNotice() {
    return (
        <Typography sx={{ fontSize: 13, color: 'text.secondary', fontStyle: 'italic' }}>
            Premiums for this quote will be left blank.
        </Typography>
    );
}
